import { render } from "./azure.vue?vue&type=template&id=463d09d9&scoped=true"
import script from "./azure.vue?vue&type=script&lang=js"
export * from "./azure.vue?vue&type=script&lang=js"

import "./azure.vue?vue&type=style&index=0&id=463d09d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463d09d9"]])

export default __exports__